"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _HotelRoomOffersMobile["default"];
  }
});
var _HotelRoomOffersMobile = _interopRequireDefault(require("./HotelRoomOffersMobile"));